import Vue from 'vue'
import Vuex from 'vuex'
import global from './modules/global'
import detail from './modules/detail'
import menu from './modules/menu'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        global,
        detail,
        menu
    }
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js